import { MapPinIcon } from "@heroicons/react/24/outline";
import { computeDirectionsUrl } from "helpers/address";
import React from "react";

export const MapLink: React.FC<{ address: string }> = ({ address }) => (
    <a
        href={computeDirectionsUrl(address, "")}
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center gap-1 text-sm text-brand-600 hover:underline">
        <MapPinIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
        <span>{address}</span>
    </a>
);
